import { Zap, TestTube2 } from "lucide-react";

/**
 * Small pill showing whether the numbers on this page are LIVE (DataForSEO)
 * or DEMO (seeded mock data). Non-intrusive; sits next to a section header.
 */
export function DataSourceBadge({ source }) {
    const live = source === "dataforseo";
    return (
        <span
            data-testid={`data-source-${live ? "live" : "demo"}`}
            title={
                live
                    ? "Live data from DataForSEO. Cached for 24h to keep costs down."
                    : "Demo data. Add DataForSEO credentials in backend .env to switch to live numbers."
            }
            className={
                "inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest border " +
                (live
                    ? "border-success/40 text-success bg-success/5"
                    : "border-warning/40 text-warning bg-warning/5")
            }
        >
            {live ? <Zap className="w-3 h-3" /> : <TestTube2 className="w-3 h-3" />}
            {live ? "Live data" : "Demo data"}
        </span>
    );
}
